export enum AnnouncementStatus {
  Active = 'Active',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Deactivated = 'Deactivated',
  Expired = 'Expired',
  Paused = 'Paused'
}

export enum PropertyType {
  NewBuild = 'new-build',
  OldBuild = 'old-build',
  House = 'house',
  Office = 'office',
  Garage = 'garage',
  Land = 'land',
  Commercial = 'commercial'
}

export enum AnnouncementType {
  Sale = 'sale',
  Rent = 'rent'
}

export enum OwnerType {
  Owner = 'owner',
  Agent = 'agent'
}

export interface LookupValue {
  id: number;
  name: string;
}

export interface ProfileListing {
  listingModerationStatus: number;
  profileDisplayStatus: number;
  hasPendingUpdate: boolean;
  id: number;
  propertyType: LookupValue;
  administrativeArea: LookupValue;
  address: string;
  price: number;
  createdDate: string;
  viewCount: number;
  renovationStatus: LookupValue;
  roomCount: LookupValue;
  areaSquareMeters: number;
  landAreaSot: number | null;
  floor: number | null;
  previewImageUrl: string;
}

export interface ProfileListingsResponse {
  success: boolean;
  data: ProfileListing[];
  error: any;
}

export interface Announcement {
  id: number;
  dealType?: number;
  propertyType: PropertyType | number | LookupValue;
  administrativeArea?: number | LookupValue;
  subAreaType?: number;
  subAreaId?: number;
  settlementId?: number | LookupValue;
  address: string;
  latitude?: number;
  longitude?: number;
  roomCount?: number | LookupValue | null;
  areaSquareMeters?: number;
  landAreaSot?: number | null;
  floor?: number | null;
  totalFloors?: number | null;
  renovationStatus?: number | LookupValue | null;
  hasDocument?: boolean;
  isMortgageAvailable?: boolean;
  description?: string;
  price: number;
  isOwner?: boolean;
  contactName?: string;
  contactEmail?: string;
  contactPhone?: string;
  viewCount?: number;
  createdDate?: string | Date;
  status?: AnnouncementStatus;
  rejectionReason?: string;
  expiresAt?: Date;
  imageUrls?: string[];
  images?: { id: number; url: string }[];
  isVip?: boolean;
  vipExpiresAt?: Date;
  previewImageUrl?: string;
  metroId?: number | null;
  metro?: LookupValue | null;
  // UI legacy fields if needed
  title?: string;
  rooms?: number | string;
  area_m2?: number;
  total_floors?: number | null;
  region?: string;
  type?: AnnouncementType;
  ownerType?: OwnerType;
  repair?: string;
  hasExtract?: boolean;
  hasMortgage?: boolean;
  createdAt?: Date;
  lat?: number;
  lng?: number;
}

export interface VipPackage {
  id: string;
  days: number;
  price: number;
}

export const VIP_PACKAGES: VipPackage[] = [
  { id: '1-day', days: 1, price: 5.00 },
  { id: '5-days', days: 5, price: 10.00 },
  { id: '15-days', days: 15, price: 20.00 },
  { id: '30-days', days: 30, price: 30.00 }
];
